
import jobIndustry from '../../gjobhub/data/JobIndustry.json'
import jobType from '../../gjobhub/data/JobType.json'
import workMode from '../../gjobhub/data/WorkMode.json'
import { handleValidationCheck, isEmpty } from "../../gjobhub/validation/Validation";
import { renderDropdownFieldFromDBList, renderTextArea, renderInputTextField } from '../../gjobhub/models/FormTemplate';
import  { useState, useEffect,axios } from '../../../src/InBuildImports';
import {Endpoint ,systemConfiguration, includeScripts,  includeBundleBootstrapCss } from '../../../src/CommonImports';
import './../css/GRecentJobs.css';
import './../css/GBrowsebycategory.css';
import './../css/GSideBar.css';
import './../css/GPostJob.css';
import './../css/GMediaQuery.css';
import './../css/Gtop.css';
import './../css/GAnimetion.css';
import './../css/GGraphicJob.css';
import './../css/GFooter.css';
import 'bootstrap/dist/css/bootstrap.min.css';


function GPostJob() {

  useEffect(() => {

    //includeBootstrapCss();
    includeBundleBootstrapCss();
    includeScripts();

  }, []);

  const [errorsJson, setErrorsJson] = useState({});


  const handleValidate = (e) => {
    const { name, value } = e.target;
    //let isValid = false;
    const res = null;//handleValidationCheck(e, setErrorsJson);
    console.log("field name::" + name);
    console.log("ErrorResponseJSON", res);
    return res;
  };

  const jobIndustryData = jobIndustry.map((obj) => {
    return obj.value;
  });

  const jobTypeData = jobType.map((obj) => {
    return obj.value;
  });

  const workModeData = workMode.map((obj) => {
    return obj.value;
  });

  const [file, setFile] = useState(null);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

  };
  const [formData, setFormData] = useState({
    id: "",
    companyJobId: "",
    companyName: "",
    aboutCompany: "",
    companyWebsiteUrl: "",
    jobPosterPersonName: "",
    jobPosterEmailId: "",
    jobIndustry: "",
    jobType: "",
    workMode: "",
    jobLocationCity: "",
    companyRecruiterName: "",
    companyRecruiterEmailId: "",
    companyRecruiterPhoneNo: "",
    skills: "",
    jobTitle: "",
    jobDescription: "",
    jobResponsibilities: "",
    budget: "",
    candidateIdFromUploadResume: [],
    requiredExperience: 0,
    companyLogoUrl: "",
    keyRequirement: "",
    qualification: "",
    noOfVacancy: "",
    creationDate: "",
    lastModifiedDate: ""
  });

  const handleImageChange = (e) => {
    setFile(e.target.files[0]);
  }
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isEmpty(errorsJson)) {
      alert('All Fields re mandatory.');
      return false;
    } else {
      const newformData = new FormData();
      const formPayload = {
        ...formData
      };

      newformData.append('data', JSON.stringify(formPayload));
      newformData.append('file', file);
      try {
        const response = await axios.post(
          `${systemConfiguration.HOST}${Endpoint.UPLOAD_JOB_POST}`,
          newformData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        alert("Data Submitted Successfully");
      }
      catch (error) {
        console.error("An error occurred while submitting the form. Please try again later.");
      }
    }
  }

  return (

    <section className="w-100 gradient-custom py-5" >
      <div className="container py-5 mb-5">
        <div className="row justify-content-left align-items-left">
          <div className="col-12 col-lg-9 col-xl-7">
            <div className="card shadow-2-strong card-registration" style={{ borderRadius: "15px" }}>
              <div className="card-body p-4 p-md-5 ">
                <h3 className="mb-2 pb-2 pb-md-0 mb-md-5">Post Job</h3>
                <form onSubmit={handleSubmit}>

                  <h5 class="mb-3 fw-semibold fs-6">Recruiter Details</h5>
                  <div className="mb-4 p-3 border rounded bg-light">
                    <div className="row">
                      <div className="col-md-6 mb-2 pb-2 mt-3">
                        <div data-mdb-input-init className="form-outline">
                          {renderInputTextField('jobPosterPersonName', 'Job poster person name', 'jobPosterPersonName', '', formData.jobPosterPersonName, 'form-control form-control-sm', handleChange, (e) => { handleValidate(e) }, errorsJson)}
                          <label className="form-label">Job Poster Person Name</label>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2 pb-2 mt-3">
                        <div data-mdb-input-init className="form-outline">
                          {renderInputTextField('jobPosterEmailId', 'Job poster email id', 'jobPosterEmailId', '', formData.jobPosterEmailId, 'form-control form-control-sm', handleChange, (e) => { handleValidate(e) }, errorsJson)}
                          <label className="form-label">Job Poster Email Id</label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 mb-2 pb-2 mt-3">
                        <div data-mdb-input-init className="form-outline">
                          {renderInputTextField('companyRecruiterName', 'Company recruiter name', '', '', formData.companyRecruiterName, 'form-control form-control-sm', handleChange, (e) => { handleValidate(e) }, errorsJson)}
                          <label className="form-label">Company Recruiter  Name</label>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2 pb-2 mt-3">
                        <div data-mdb-input-init className="form-outline">
                          {renderInputTextField('companyRecruiterEmailId', 'Company recruiter email', '', '', formData.companyRecruiterEmailId, 'form-control form-control-sm', handleChange, (e) => { handleValidate(e) }, errorsJson)}
                          <label className="form-label">Company Recruiter Email</label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 mb-2 pb-2 mt-3">
                        <div data-mdb-input-init className="form-outline">
                          {renderInputTextField('companyRecruiterPhoneNo', 'Company recruiter phone', '', '', formData.companyRecruiterPhoneNo, 'form-control form-control-sm', handleChange, (e) => { handleValidate(e) }, errorsJson)}
                          <label className="form-label">Company Recruiter Phone</label>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2 pb-2 mt-3">
                        <div data-mdb-input-init className="form-outline">
                          {renderInputTextField('companyName', 'Company name', 'companyName', '', formData.companyName, 'form-control form-control-sm', handleChange, (e) => { handleValidate(e) }, errorsJson)}
                          <label className="form-label">Company Name</label>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2 pb-2">
                        <div data-mdb-input-init className="form-outline">
                          {renderTextArea('aboutCompany', 'About Company', '', '', formData.aboutCompany, 'form-control', handleChange, (e) => { handleValidate(e) }, errorsJson)}
                          <label className="form-label">About Company</label>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2 pb-2">
                        <div data-mdb-input-init className="form-outline">
                          <input
                            name="uploadCompayLogoUrl"
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            className="form-control form-control-sm"
                          />
                          <label className="form-label">Company Logo</label>
                        </div>

                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 mb-2 pb-2 mt-3">
                        <div data-mdb-input-init className="form-outline">
                          {renderInputTextField('companyWebsiteUrl', 'Company website url', 'companyWebsiteUrl', '', formData.companyWebsiteUrl, 'form-control form-control-sm', handleChange, (e) => { handleValidate(e) }, errorsJson)}
                          <label className="form-label">Company Websit eUrl</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h5 class="mb-3 fw-semibold fs-6">Job Details</h5>
                  <div className="mb-4 p-3 border rounded bg-light">

                    <div className="row">
                      <div className="col-md-4 mb-2 mt-3">
                        <div data-mdb-input-init className="form-outline">
                          {renderInputTextField('companyJobId', 'Job Id', 'Job Id', '', formData.companyJobId, 'form-control form-control-sm', handleChange, (e) => { handleValidate(e) }, errorsJson)}
                          <label className="form-label">Job Id</label>
                        </div>
                      </div>
                      <div className="col-md-4 mb-2 mt-3">
                        <div data-mdb-input-init className="form-outline">
                          {renderInputTextField('jobLocationCity', 'Job location', 'jobLocationCity', '', formData.jobLocationCity, 'form-control form-control-sm', handleChange, (e) => { handleValidate(e) }, errorsJson)}
                          <label className="form-label">Job Location</label>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-4 mb-2 mt-3">
                        <div data-mdb-input-init className="form-outline">
                          {renderInputTextField('jobTitle', 'Job title', 'Job Title', '', formData.jobTitle, 'form-control form-control-sm', handleChange, (e) => { handleValidate(e) }, errorsJson)}
                          <label className="form-label">Job Title</label>
                        </div>
                      </div>
                      <div className="col-md-4 mb-2 mt-3">
                        <div data-mdb-input-init className="form-outline">
                          {renderDropdownFieldFromDBList('jobIndustry', 'Job industry', 'jobIndustry', formData.jobIndustry, jobIndustryData, 'form-control form-control-sm', handleChange, (e) => { handleValidate(e) }, errorsJson)}
                          <label className="form-label">Job Industry</label>
                        </div>
                      </div>
                      <div className="col-md-4 mb-2 mt-3">
                        <div data-mdb-input-init className="form-outline">
                          {renderDropdownFieldFromDBList('jobType', 'Job type', 'jobType', formData.jobType, jobTypeData, 'form-control form-control-sm', handleChange, (e) => { handleValidate(e) }, errorsJson)}
                          <label className="form-label">Job Type</label>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-4 mb-2 mt-3">
                        <div data-mdb-input-init className="form-outline">
                          {renderDropdownFieldFromDBList('workMode', 'Work mode', 'workMode', formData.workMode, workModeData, 'form-control form-control-sm', handleChange, (e) => { handleValidate(e) }, errorsJson)}
                          <label className="form-label">Work Mode</label>
                        </div>
                      </div>
                      <div className="col-md-4 mb-2 mt-3">
                        <div data-mdb-input-init className="form-outline">
                          {renderInputTextField('budget', 'Salary budget', 'budget', '', formData.budget, 'form-control form-control-sm', handleChange, (e) => { handleValidate(e) }, errorsJson)}
                          <label className="form-label">Salary Budget</label>
                        </div>
                      </div>
                      <div className="col-md-4 mb-2 mt-3">
                        <div data-mdb-input-init className="form-outline">
                          {renderInputTextField('noOfVacancy', 'No of vacancy', 'noOfVacancy', '', formData.noOfVacancy, 'form-control form-control-sm', handleChange, (e) => { handleValidate(e) }, errorsJson)}
                          <label className="form-label">No Of Vacancy</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h5 class="mb-3 fw-semibold fs-6">Job Requirement</h5>
                  <div className="mb-4 p-3 border rounded bg-light">
                    <div className="row">
                      <div className="col-md-4 mb-2 pb-2 mt-3">
                        <div data-mdb-input-init className="form-outline">
                          {renderInputTextField('skills', 'Skills', 'skills', '', formData.skills, 'form-control form-control-sm', handleChange, (e) => { handleValidate(e) }, errorsJson)}
                          <label className="form-label">Skills</label>
                        </div>
                      </div>
                      <div className="col-md-4 mb-2 pb-2 mt-3">
                        <div data-mdb-input-init className="form-outline">
                          {renderInputTextField('requiredExperience', 'Experience', 'Experience', '', formData.requiredExperience, 'form-control form-control-sm', handleChange, (e) => { handleValidate(e) }, errorsJson)}
                          <label className="form-label">Experience</label>
                        </div>
                      </div>
                      <div className="col-md-4 mb-2 pb-2 mt-3">
                        <div data-mdb-input-init className="form-outline">
                          {renderInputTextField('qualification', 'Qualification', 'qualification', '', formData.qualification, 'form-control form-control-sm', handleChange, (e) => { handleValidate(e) }, errorsJson)}
                          <label className="form-label">Qualification</label>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-2 pb-2">
                        <div data-mdb-input-init className="form-outline">
                          {/* <textarea className="form-control" rows="3" placeholder="Job Description"></textarea> */}
                          {renderTextArea('jobDescription', 'Job description', '', '', formData.jobDescription, 'form-control', handleChange, (e) => { handleValidate(e) }, errorsJson)}
                          <label className="form-label">Job Description</label>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2 pb-2">
                        <div data-mdb-input-init className="form-outline">
                          {renderTextArea('jobResponsibilities', 'Job responsibilities', '', '', formData.jobResponsibilities, 'form-control', handleChange, (e) => { handleValidate(e) }, errorsJson)}
                          <label className="form-label">Job Responsibilities</label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 mb-2 pb-2">
                        <div data-mdb-input-init className="form-outline">
                          {renderTextArea('keyRequirement', 'Key Requirement', '', '', formData.keyRequirement, 'form-control', handleChange, (e) => { handleValidate(e) }, errorsJson)}
                          <label className="form-label">Key Requirement</label>
                        </div>
                      </div>
                    </div>


                  </div>

                  <div className="Gbuttons h-100 w-100">
                    <input className="btn btn-primary btn-lg" type="submit" value="Submit" />
                  </div>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  )
}
export default GPostJob;